import React from 'react';
import { Mail } from 'lucide-react';
import T from '../components/T';

const ContactMe = () => {
  const handleEmailClick = () => {
    window.location.href = 'mailto:personal@pfjacobs.com';
  };

  return (
    <section className="py-16 bg-[var(--color-bg-section)] transition-colors duration-300" style={{fontFamily: 'Short Stack, cursive'}}>
      <div className="container mx-auto px-6">
        <h2 className="text-2xl md:text-3xl text-center mb-4 text-[var(--color-text-primary)] transition-colors duration-300" style={{fontFamily: 'Indie Flower, cursive'}}><T k="homepage.contact.title" /></h2>
        <p className="text-base lg:text-lg text-center mb-8 text-[var(--color-text-secondary)] transition-colors duration-300" style={{fontFamily: 'Short Stack, cursive'}}>
          <T k="homepage.contact.description" />
        </p>
        <div className="flex flex-col items-center">
          <button
            onClick={handleEmailClick}
            className="inline-flex items-center px-6 py-3 text-lg font-bold rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors duration-300"
            style={{backgroundColor: 'var(--color-btn-primary)', color: 'var(--color-btn-text)', fontFamily: 'Short Stack, cursive'}}
          >
            <Mail className="w-6 h-6 mr-2" />
            <T k="homepage.contact.button" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ContactMe;